// extracted by mini-css-extract-plugin
export default {"schedule-card-item":"ScheduleCard_schedule-card-item__elxnc","schedule-card-item__title":"ScheduleCard_schedule-card-item__title__scwaC"};